var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3275 18C37.3275 8.05887 29.1378 0 19.0353 0C8.93285 0 0.743164 8.05887 0.743164 18C0.743164 26.9843 7.43235 34.431 16.1772 35.7812V23.2031H11.5327V18H16.1772V14.0344C16.1772 9.52312 18.9081 7.03125 23.0864 7.03125C25.0877 7.03125 27.1811 7.38281 27.1811 7.38281V11.8125H24.8744C22.6021 11.8125 21.8935 13.2 21.8935 14.6235V18H26.9667L26.1557 23.2031H21.8935V35.7812C30.6383 34.431 37.3275 26.9843 37.3275 18Z",
    fill: "#0A4B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1557 23.2031L26.9667 18H21.8935V14.6235C21.8935 13.2 22.6022 11.8125 24.8745 11.8125H27.1811V7.38281C27.1811 7.38281 25.0878 7.03125 23.0864 7.03125C18.9081 7.03125 16.1772 9.52312 16.1772 14.0344V18H11.5327V23.2031H16.1772V35.7812C18.0711 36.0729 19.9996 36.0729 21.8935 35.7812V23.2031H26.1557Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5843,
    height: 36,
    fill: "white",
    transform: "translate(0.743164)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/Facebook-logo.59198c7fd1ffb87daeb6a3d6b5222fc6.svg";
export { ForwardRef as ReactComponent };